import React, { useContext } from "react";
import { ThemeContext } from "../../Context/ThemeContext.js";
import './NewHeader.css'
import logo from '../../images/logo.png'


const NewHeader = () => {

    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;

    const onClick = () => {
        document.body.classList.toggle('overlay');
        document.body.classList.toggle('overlay-light');
        if (darkMode) {
            theme.dispatch({ type: "LIGHTMODE" });
            document.body.classList.toggle('light-theme');
        } else {
            theme.dispatch({ type: "DARKMODE" });
            document.body.classList.toggle('light-theme');
        }
    };

    return (
        <div className='navbar'>
            <div className="left">
                <a href="/" className="logo"><img src={logo} alt="Logo" /></a>
                <div className="nav-menu">
                    <a href="/"><span className="nav-items">About</span></a>
                    <a href="/"><span className="nav-items">Vote</span></a>
                    <a href="/"><span className="nav-items">Presale</span></a>
                    <a href="/"><span className="nav-items">Whitepaper</span></a>
                </div>
            </div>
            <div className="right">
                <div className="toggle-div">
                    <label className="switch" >
                        <input type="checkbox" onClick={() => { onClick() }} />
                        <span className="slider"></span>
                    </label>
                   
                </div>
                <div className="lang-div">
                        <span>En</span>
                        <img className="lang-drop" src="/drop.svg" alt="" />
                    </div>
                <a href="/" className='button nav-btn'>
                    <span>Connect Wallet</span>
                    <img className="arrow" src="/arrow.svg" alt="" />
                </a>
            </div>
        </div>
    )
}

export default NewHeader